import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import css from '../css/document.m.css';
let Document = class Document extends I18nThemed {
    render() {
        const { title, text, id } = this.properties;
        return v('div', { classes: [this.theme(css.root)], id }, [
            v('h1', { classes: [this.theme(css.heading)] }, [title]),
            v('article', { classes: [this.theme(css.article)], innerHTML: text.data })
        ]);
    }
};
Document = __decorate([
    theme(css)
], Document);
export { Document };
